import { Component, Input, OnInit } from '@angular/core';
import { ScheduledEvent, ScheduledEventInstructor } from '../../../../../../../../models/scheduled-event';
import { SelectStaffUserModalComponent } from '../../../../../modals/select-staff-user-modal/select-staff-user-modal.component';
import { User } from '../../../../../../../../models/user';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../../../../../../services/event/event.service';
import { AccountService } from '../../../../../../../../services/account/account.service';


@Component({
  selector: 'app-set-event-part-instructors-modal',
  templateUrl: './set-event-part-instructors-modal.component.html',
  styleUrls: ['./set-event-part-instructors-modal.component.css']
})
export class SetEventPartInstructorsModalComponent implements OnInit {

  @Input() eventPart: ScheduledEvent;
  @Input() savedCallback: () => undefined;

  public instructors: ScheduledEventInstructor[] = [];

  public loadingSave = false;
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private modalService: NgbModal,
    private eventService: EventService
  ) {}

  ngOnInit() {
    // Create a deep copy of the event part's instructors, so edits are only
    // reflected after they're saved.
    for (const epi of this.eventPart.instructors) {
      this.instructors.push({...epi});
    }
  }

  public handleSave() {
    this.loadingSave = true;

    this.eventService
      .setEventPartInstructors(
        this.eventPart.event_part_id,
        this.instructors.map(i => {
          return {
            id: i.id,
            is_sub: i.is_sub
          };
        })
      )
      .then(() => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

}
